import styles from './CBComponent.module.css'
import { DSCBComponent, DSTpl } from 'shared-definitions/types'
import ComponentTitle from 'shared-components/ui/ComponentTitle'
import { CBAdsControlContext } from 'shared-components/contexts/CBAdsControlContext'
import NC from 'nc/NC'
import { DSNCSG } from 'types.sg.ds'
import clsx from 'clsx'

interface CBComponentProps {
  data: DSCBComponent<DSNCSG>
  tpl: DSTpl
}

const CBComponent: React.VFC<CBComponentProps> = ({ data, tpl }) => {
  const { voidQuantity } = CBAdsControlContext.useContainer()

  if (data.component.length === voidQuantity) {
    return null
  }

  let newTpl = tpl
  if (data.fullWidth && newTpl === 'home') {
    newTpl = 'home-full-width'
  }

  return (
    <div
      className={clsx(styles.container, {
        [styles.fullWidth]: data.fullWidth,
      })}
    >
      <ComponentTitle header={data.header} />
      {data.component.map((item, index) => (
        <NC key={index} data={item} tpl={newTpl} index={index} />
      ))}
    </div>
  )
}

export default CBComponent
